<template>
  <v-card :loading="loadingCard">
    <v-card-title>
      <v-row justify="space-between">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.sendMessage') }}</span>
        <v-btn icon @click.stop="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-form v-model="isFormValid" ref="mailForm">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="mail.message"
              rows="3"
              outlined
              no-resize
              :rules="[rules.required, rules.minCharacters(mail.message, 20)]"
              dense>
            </v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small depressed :disabled="loadingCard" @click.stop="close">{{ $t('label.close') }}</v-btn>
        <v-btn small depressed color="primary" :disabled="loadingCard || !isFormValid" @click.stop="sendMail">{{ $t('label.send') }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { loading, rules, showMessage } from '../../../mixins'
export default {
  name: 'PurchaseOrderMail',
  props: {
    purchaseOrderId: Number
  },
  mixins: [loading, showMessage, rules],
  data: () => ({
    loadingCard: false,
    isFormValid: null,
    mail: {
      message: ''
    }
  }),
  methods: {
    sendMail () {
      alert('TODO send mail')
    },
    clearForm () {
      this.mail = {
        message: ''
      }
      this.$refs.mailForm.resetValidation()
    },
    close () {
      this.clearForm()
      this.$emit('close')
    }
  }
}
</script>

<style>

</style>
